import { useEffect } from 'react';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import { testimonialsData } from '../../mocks/testimonials';

const TestimonialsPage = () => {
  useEffect(() => {
    document.title = 'Client Reviews & Testimonials | Bold Plans Advisory Jacksonville FL';
    const meta = document.querySelector('meta[name="description"]');
    if (meta) meta.setAttribute('content', 'Read real client success stories and reviews for Bold Plans Advisory in Jacksonville, Florida. See how our tax preparation and financial advisory services have helped individuals and businesses.');
    const canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) canonical.setAttribute('href', `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/testimonials`);

    const scriptId = 'schema-testimonials';
    document.getElementById(scriptId)?.remove();
    const script = document.createElement('script');
    script.id = scriptId;
    script.type = 'application/ld+json';
    script.text = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "WebPage",
      "url": `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/testimonials`,
      "name": "Client Reviews & Testimonials | Bold Plans Advisory",
      "description": "Real client success stories and reviews for Bold Plans Advisory tax preparation and financial advisory services in Jacksonville, Florida.",
      "review": testimonialsData.map((t) => ({
        "@type": "Review",
        "author": { "@type": "Person", "name": t.name },
        "reviewRating": {
          "@type": "Rating",
          "ratingValue": t.rating,
          "bestRating": "5"
        },
        "reviewBody": t.quote
      }))
    });
    document.head.appendChild(script);
    return () => { document.getElementById(scriptId)?.remove(); };
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <main className="pt-20">
        <section className="py-24 bg-gradient-to-br from-orange-500 to-orange-600 text-white">
          <div className="max-w-7xl mx-auto px-6 lg:px-8 text-center">
            <h1 className="font-montserrat font-bold text-6xl mb-6">Client Success Stories</h1>
            <p className="text-xl text-white/90 font-sans max-w-3xl mx-auto">
              Hear from our satisfied clients about how we helped them save money and achieve their financial goals
            </p>
          </div>
        </section>

        <section className="py-24">
          <div className="max-w-7xl mx-auto px-6 lg:px-8">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
              {testimonialsData.map((testimonial) => (
                <div
                  key={testimonial.id}
                  className="bg-white border-2 border-gray-100 rounded-3xl p-8 hover:border-orange-500 hover:shadow-xl transition-all duration-300"
                >
                  <div className="mb-6">
                    <h3 className="font-montserrat font-bold text-xl text-gray-900 mb-1">
                      {testimonial.name}
                    </h3>
                    <p className="text-gray-600 font-sans text-sm mb-3">{testimonial.role}</p>
                    <div className="flex gap-1">
                      {[...Array(testimonial.rating)].map((_, i) => (
                        <i key={i} className="ri-star-fill text-orange-500 text-lg"></i>
                      ))}
                    </div>
                  </div>
                  <blockquote className="text-gray-700 font-sans leading-relaxed">
                    "{testimonial.quote}"
                  </blockquote>
                </div>
              ))}
            </div>

            <div className="mt-16 bg-cream-50 rounded-3xl p-12 text-center">
              <h2 className="font-montserrat font-bold text-4xl text-gray-900 mb-4">
                Ready to Join Our Success Stories?
              </h2>
              <p className="text-gray-600 font-sans text-lg mb-8 max-w-2xl mx-auto">
                Experience the same level of expertise and personalized service that our clients rave about. Schedule your consultation today.
              </p>
              <a
                href="/contact"
                className="inline-flex items-center gap-2 bg-orange-500 text-white px-8 py-4 rounded-full font-sans font-semibold hover:bg-orange-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                Get Started Today
                <i className="ri-arrow-right-line"></i>
              </a>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default TestimonialsPage;
